import angular from 'angular'

import areaModule from './area/area.module'
import dispatchModule from './dispatch/dispatch.module'
import movementModule from './movement/movement.module'
import ownerModule from './owner/owner.module'
import railwayModule from './railway/railway.module'
import trainModule from './train/train.module'
import wagonModule from './wagon/wagon.module'
import statModule from './stat/stat.module'
import listModule from './list/list.module'
import commandeModule from './commande/commande.module'
import searchModule from './search/search.module'

import consultRun from './consult.run'
import consultRoutes from './consult.routes'
import consultMenu from './consult.menu'

const name = 'routingConsult'

angular.module(name, [
  areaModule,
  dispatchModule,
  movementModule,
  ownerModule,
  railwayModule,
  trainModule,
  wagonModule,
  statModule,
  listModule,
  commandeModule,
  searchModule,
])
  .run(consultRun)
  .config(consultRoutes)
  .factory('consultMenu', consultMenu)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/consult.module.js